/**
 * Converts a rem value to pixels
 * @param {number} remValue - The rem value to convert
 * @returns {number} The equivalent value in pixels
 */
export function remToPx(remValue) {
  // Get the root font size (usually 16px by default)
  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);

  // Convert rem to pixels
  return remValue * rootFontSize;
}

/**
 * Alternative version that doesn't rely on DOM (useful for server-side or when DOM isn't available)
 * @param {number} remValue - The rem value to convert
 * @param {number} baseFontSize - The base font size in pixels (defaults to 16)
 * @returns {number} The equivalent value in pixels
 */
export function remToPxStatic(remValue, baseFontSize = 16) {
  return remValue * baseFontSize;
}
